<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <title2 title="环节监控">
      <div class="ztc">
        <zhengti @getactive="getactive"></zhengti>
      </div>
    </title2>
    <div class="paiming2" v-if="active==0">
      <p class="biaoti">
        本市企业开办流程个数为3个,其中包含联办事项:企业登记和公章制作,联办事项算作个流程;较第名上海多2个流程, 分布为申请外商批准和名称预先核准
      </p>
      <div class="paimingk">
        <div ref="myChart1" style="width: 614px;height: 400px"></div>
        <div ref="myChart2" style="width: 614px;height: 400px"></div>
      </div>
    </div>
    <div v-if="active==1">
      <jiankong2></jiankong2>
    </div>
  </div>
</template>

<script>
import title2 from "@/components/title";
import zhengti from "@/components/qiyekaiban/zhengti";
import jiankong2 from "@/components/qiyekaiban/jiankong2";

export default {
  name: "paiming",
  components: {title2, zhengti, jiankong2},
  data: function () {
    return {
      active: 0,
      list: [{
        title: '上海',
        day: 1,
        fenshu: 96
      }, {
        title: '大连',
        day: 1,

        fenshu: 96
      }, {
        title: '北京',
        day: 1,

        fenshu: 96
      }, {
        title: '深圳',
        day: 1,
        fenshu: 96
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  filters: {},
  methods: {
    getactive(e) {
      this.active = e;
      this.$nextTick(function () {
        this.drawLine();
        this.drawLine2();
      })
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      // let myChart = this.$echarts.init(document.getElementById('myChart6'))
      let myChart = this.$echarts.init(this.$refs.myChart1)
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '0%',
          left: '0',
          bottom: '19%'
        },
        title: {
          text: '环节个数',
          x: '250',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['大连', '北京', '上海', '深圳'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            show: false,
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,

            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [3, 1, 1, 1],
          barWidth: '40px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(236, 141, 91, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
          label: {
            formatter: "{c}" + "个",
            show: true,
            position: "top",
            textStyle: {
              fontWeight: "bolder",
              fontSize: "28",
              color: "#fff"
            }
          },
        }
        ]
      });
    },
    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.myChart2)
      // let myChart = this.$echarts.init(document.getElementById('myChart7'))
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '0%',
          left: '0%',
          bottom: '19%'
        },
        title: {
          text: '评价得分',
          x: '250',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },

        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: [ '上海','北京', '深圳', '大连'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            show: false,
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(111, 118, 142, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,

            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 50, 40],
          barWidth: '40px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
          label: {
            formatter: "{c}" + "分",
            show: true,
            position: "top",
            textStyle: {
              fontWeight: "bolder",
              fontSize: "28",
              color: "#fff"
            }
          },
        }
        ]
      });
    },
  },
  mounted() {
    this.drawLine();
    this.drawLine2();
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 20px;

}

.paiming2 {
  height: 456px;

  .head {
    width: 558px;
    height: 74px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 560px;
  margin: auto;
}

.bodyitem {
  height: 73px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.biaoti {
  height: 57px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-bottom: 30px;
  margin-top: -25px;
}

.paimingk {
  @include flex_start_start();
}

.paiming4 {
  margin-left: 30px;
  @include flex_center_center();
}

.ztc {
  padding-top: 20px;
}
</style>
